import { AxiosPromise } from 'axios';
import { IListResponse } from '../../../model/listResponse';
import IPricesResponse from '../../../../productCatalog/models/IPricesResponse';
import {
  DataLayerEvent,
  DataLayerFormName,
  DataLayerFormStage,
} from '../../../../../../common/utilities/customDatalayerInterface';
import digitalDataAssignment from '../../../../../../common/utilities/digitalDataAssignment';
import dataLayerToggleVerification from '../../../../../../common/utilities/dataLayerToggleVerification';
import IDimensions from '../../../model/IDimensions';
import { customerStorage } from '../../../../../../common/service/customerStorage';

const CatalogDataLayerRest = async (
  promiseList: AxiosPromise<IListResponse>,
  promisePrice: AxiosPromise<IPricesResponse>,
  dimension: IDimensions,
): Promise<void> => {
  const isDataLayer = dataLayerToggleVerification(dimension);

  try {
    if (isDataLayer) {
      const customerStorageValue = customerStorage.getCustomerData(dimension);
      await Promise.all([promiseList, promisePrice]).then(promiseValues => {
        const responseList: IListResponse = promiseValues[0]?.data;
        const responsePrice: IPricesResponse = promiseValues[1]?.data;

        const modelList = Object.values(responsePrice?.items).map((item, index) => {
          return {
            model: responseList?.items[index].name,
            driveAwayPricing: item.distributionPrice,
            manufacturerListPricing: item.price,
          };
        });

        digitalDataAssignment({
          event: DataLayerEvent.FORM_NAVIGATE,
          form: {
            name: DataLayerFormName.CONFIGURATOR,
            stage: DataLayerFormStage.CATALOG,
            details: {
              configurator: {
                financeOption: Object.values(responsePrice)[0]?.finance?.type,
                modelList: modelList,
              },
            },
          },
          user: {
            postCode: customerStorageValue?.postcode,
          },
        });
      });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('DataLayer error', err);
  }
};

export default CatalogDataLayerRest;
